var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"text-center pt-6"},[_c('v-img',{staticClass:"mx-auto",attrs:{"src":require("@/assets/img/icon.svg"),"width":"80"}}),_c('div',{staticClass:"px-9"},[_c('DrawerUpdate')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }